import type {UseMutationResult} from '@tanstack/react-query';
import {useMutation} from '@tanstack/react-query';
import useOidcFetch from '@/hooks/useOidcFetch';
import {apiUrl} from '@/utils/api';

type CreateUserMetricValues = {
    path : string;
    userDisplayName : string;
};

export const useCreateUserMetricMutation = () : UseMutationResult<void, unknown, CreateUserMetricValues> => {
    const fetch = useOidcFetch();

    return useMutation(async (values : CreateUserMetricValues) => {
        const response = await fetch(apiUrl('/user-metrics').toString(), {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            console.error('Failed to log user metric: ', values);
        }
    });
};
